var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSeventyPercent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1723_974)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1723_974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1723_974)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1723_974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7144 5.71436C18.2172 5.71436 18.7029 5.90293 19.0744 6.24578C19.4458 6.58864 19.6686 7.05721 19.7086 7.56007V7.70864V8.70864C20.2115 8.70864 20.6972 8.89721 21.0686 9.24007C21.4401 9.58293 21.6629 10.0515 21.7029 10.5544V10.7029V12.7029C21.7029 13.2058 21.5144 13.6915 21.1715 14.0629C20.8286 14.4344 20.3601 14.6572 19.8572 14.6972H19.7086V15.7029C19.7086 16.2058 19.5201 16.6915 19.1772 17.0629C18.8344 17.4344 18.3658 17.6572 17.8629 17.6972H17.7144H3.71436C3.2115 17.6972 2.72578 17.5086 2.35436 17.1658C1.98293 16.8229 1.76007 16.3544 1.72007 15.8515V15.7029L1.71436 7.71436C1.71436 7.2115 1.90293 6.72578 2.24578 6.35436C2.58864 5.98293 3.06293 5.76007 3.56578 5.71436H3.71436H17.7144ZM17.7144 7.71436H3.71436V15.7144H17.7144V7.71436ZM6.25721 8.71436C6.52007 8.71436 6.77721 8.81721 6.96578 9.00578C7.15436 9.19436 7.25721 9.44578 7.25721 9.71436V13.7144C7.25721 13.9772 7.14864 14.2344 6.96578 14.4229C6.78293 14.6115 6.52578 14.7144 6.25721 14.7144C5.98864 14.7144 5.73721 14.6115 5.54864 14.4229C5.36007 14.2344 5.25721 13.9829 5.25721 13.7144V9.71436C5.25721 9.4515 5.36578 9.19436 5.54864 9.00578C5.73721 8.81721 5.98864 8.71436 6.25721 8.71436ZM9.2115 8.71436C9.45721 8.71436 9.6915 8.80578 9.87436 8.96578C10.0572 9.12578 10.1715 9.35436 10.2001 9.59436V9.70864L10.2058 13.7086C10.2058 13.9658 10.1086 14.2115 9.9315 14.3944C9.75436 14.5772 9.52007 14.6915 9.26293 14.7086C9.00578 14.7258 8.76007 14.6401 8.56007 14.4744C8.36578 14.3086 8.24007 14.0801 8.2115 13.8229V13.7086L8.20578 9.70864C8.20578 9.44578 8.30864 9.18864 8.49721 9.00007C8.68578 8.8115 8.93721 8.70864 9.20578 8.70864L9.2115 8.71436ZM12.1886 8.6915C12.4344 8.6915 12.6686 8.78293 12.8515 8.94293C13.0344 9.10293 13.1486 9.3315 13.1772 9.5715V9.68578L13.1829 13.6858C13.1829 13.9429 13.0858 14.1886 12.9086 14.3715C12.7315 14.5544 12.4972 14.6686 12.2401 14.6858C11.9829 14.7029 11.7372 14.6172 11.5372 14.4515C11.3429 14.2858 11.2172 14.0572 11.1886 13.8001V13.6858L11.1829 9.68578C11.1829 9.42293 11.2858 9.16578 11.4744 8.97721C11.6629 8.78864 11.9144 8.68578 12.1829 8.68578L12.1886 8.6915Z",
    fill: "#53A35B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1723_974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1723_974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12,
    fill: "white",
    transform: "translate(1.71436 5.71436)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSeventyPercent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/seventyPercent.fdaa4da3.svg";
export { ForwardRef as ReactComponent };